import Head from "next/head";

import config from "config";
import { AuthLayout } from "auth";
import ProjectListing from "data-apps/sales-effectiveness/Listing";

const ProjectListingPage = () => {
  return <ProjectListing />;
};

ProjectListingPage.getLayout = (page) => (
  <>
    <Head>
      <title>{config.SITE_NAME} | Sales Effectiveness</title>
    </Head>
    {/* We want users to still see their files. */}
    <AuthLayout stopExpiredUsers={false}>{page}</AuthLayout>
  </>
);

export default ProjectListingPage;
